import styled from "styled-components";
import bgDark from "@/assets/images/bg_dark.png";
import bgLight from "@/assets/images/bg_light.png";

export const MContentContainer = styled.div<{ isDarkMode?: any }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({theme}) => theme.body};
  // background-image: url(${(props) => (props.isDarkMode ? bgLight : bgDark)});
  //background-repeat: no-repeat;
  //background-position: center;
  //background-size: cover;

  /* ::-webkit-scrollbar {
      display: none !important;
    }
  
    ::-moz-scrollbar {
      display: none !important;
    } */
`;

export const MView = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  background: ${({ theme }) => theme.itemBg},
`;

export const MText = styled.div<{
  size?: number;
  hoverColor?: string;
}>`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  font-family: "Roboto";
  color: ${(props) => props.theme.COLORS.textw};
  font-size: 12px;
  &:hover {
    ${({ hoverColor }) => hoverColor && `color: ${hoverColor} !important;`}
  }
  @media screen and (max-width: 800px) and (min-width: 600px) {
    font-size: 14px;
  }
`;
